/**
 * Resolve where a dashboard recent-order row should navigate.
 * Returns { pathname, state? } or null if not navigable.
 */
export function getDashboardOrderDestination(order, { fromDate, toDate } = {}) {
  if (!order?.sales_id) return null;

  const status = (order.status_code || order.status || "").toLowerCase();
  const orderType = (order.order_type || "").toUpperCase();

  const billRef = order.bill_number || order.id;

  if (status === "held") {
    return {
      pathname: "/pos",
      state: { openBillId: order.sales_id, recallIfHeld: true },
    };
  }

  if (
    orderType === "DL" &&
    status !== "paid" &&
    status !== "partial_return"
  ) {
    return {
      pathname: "/delivery",
      state: { searchBill: billRef },
    };
  }

  if (status === "open") {
    return {
      pathname: "/pos",
      state: { openBillId: order.sales_id },
    };
  }

  if (status === "paid" || status === "partial_return") {
    return {
      pathname: "/reports/daily-sales",
      state: {
        highlightBill: billRef,
        fromDate: order.activity_date || fromDate,
        toDate: order.activity_date || toDate,
      },
    };
  }

  if (order.delivery_status === "dispatched" || order.delivery_status === "delivered") {
    return {
      pathname: "/delivery",
      state: { searchBill: billRef },
    };
  }

  return null;
}
